module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0059.jpg?v=4cd4b6cb";